import React from 'react';
import {
  AfterSubmitFunc,
  FormTemplate,
  TextInput,
  useShowContextRequired
} from 'ui-builder';
import { OpenFormIconButton } from 'features/nekst-widgets';
import {
  DocumentsTemplate,
  UpdateDocumentsTemplateRequest,
  useDocumentsTemplatesService
} from 'nekst-api';
import { DocumentLabelsDropdown } from 'features/tasks-forms';

export default function UpdateDocumentsTemplateForm(
  props: {
    data: DocumentsTemplate,
    afterSubmitFunc?: AfterSubmitFunc,
  },
) {

  const documentsTemplateService = useDocumentsTemplatesService();
  return (
    <FormTemplate<UpdateDocumentsTemplateRequest>
      title="Update Template"
      submitFormFunc={(data) => documentsTemplateService.updateDocumentsTemplate(
        props.data.id,
        data,
      )}
      initialData={{
        name: props.data.name,
        labelsIds: props.data.labelsIds,
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <TextInput source="name" label="Name" />
      <DocumentLabelsDropdown source="labelsIds" label="Document Labels" />
    </FormTemplate>
  );
}

export function UpdateDocumentsTemplateButton() {
  const showContext = useShowContextRequired<DocumentsTemplate>();

  const template = showContext.data;

  return (
    <OpenFormIconButton
      title="Update Template"
      form={<UpdateDocumentsTemplateForm data={template} />}
    />
  );
}
